<template>
    <div class="block-editor send-email">
        <div class="wrapper">
            <div class="title">From:</div>
            <div class="text-editor-wrapper">
                <a-select v-model="clone.from" :defaultValue="null">
                    <a-select-option :selected="true" value="null">👉Select Email Sender...</a-select-option>
                    <a-select-option
                        :key="senderMailAddress.mail"
                        v-for="senderMailAddress of senderMailAddresses"
                        :value="senderMailAddress.mail"
                    >
                        {{ senderMailAddress.mail }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div class="wrapper">
            <div class="title">To:</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    placeholder="to mail address"
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.to"
                />
            </div>
        </div>

        <div class="wrapper">
            <div class="title">Mail İçeriği:</div>
            <div class="text-editor-wrapper">
                <a-select v-model="clone.type" :defaultValue="null">
                    <a-select-option value="custom"> Custom</a-select-option>
                    <a-select-option value="template">Özel Şablon</a-select-option>
                </a-select>
            </div>
        </div>
        <template v-if="clone.type === 'template'">
            <div class="wrapper">
                <div class="title">Mail Şablonu:</div>
                <div class="text-editor-wrapper">
                    <a-select v-model="clone.templateId" :defaultValue="null">
                        <a-select-option :selected="true" value="null">👉Select Email Template...</a-select-option>
                        <a-select-option :key="template.id" v-for="template of templates" :value="template._id">
                            {{ template.name }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
        </template>
        <template v-if="clone.type === 'custom'">
            <div class="wrapper">
                <div class="title">Subject:</div>
                <div class="text-editor-wrapper">
                    <input
                        type="text"
                        placeholder="Subject"
                        v-model="clone.subject"
                        style="border: none; padding: 5px"
                    />
                </div>
            </div>
            <div class="wrapper">
                <div class="title">Content:</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="to mail address"
                        :show-attributes="true"
                        :show-emoji="false"
                        v-model="clone.content"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapActions, mapState } from "vuex";
import { MAIL_API } from "../../../../../../api/mail";

const log = log2("SendMail");
export default {
    name: "SendMail",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            senderMailAddresses: [],
            defaultMail: "",
            templates: [],
        };
    },
    computed: {
        ...mapState({
            allMailAddresses: (state) => state.mail.allMailAddresses,
        }),
    },
    methods: {
        ...mapActions({}),
        async fetch() {
            const { templates, total } = await MAIL_API.TEMPLATE.listEmailTemplates();
            this.templates = templates;
            this.paginationCursor.total = total;
        },
    },
    mounted() {
        if (!this.clone.type) this.clone.type = "custom";

        this.senderMailAddresses = this.allMailAddresses.filter(
            (x) => !!x.isSender && (!!x.isSenderVerified || !!x.isVerified)
        );
        //        this.senderMailAddresses = [{ mail: "info@supsis.com" }, ...this.senderMailAddresses];
    },
    watch: {
        clone: {
            immediate: true,
            deep: true,
            handler(newValue) {
                if (newValue.type === "template") this.fetch();
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.send-email {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .wrapper {
        padding: 10px;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            input {
                width: 100%;
            }

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .ant-select {
            width: 100%;
        }
    }
}
</style>
